// How the lock-in payment sheet asks Stripe for its form: card only, on the server's API release.
// No imports, so the tests can check these exact options.

/**
 * Stripe asks that Stripe.js always load from js.stripe.com, never from a copy. The versioned script
 * on the same release as the server's pinned API version (src/payments.ts STRIPE_API_VERSION, Endive):
 * the old evergreen /v3/ script ignores allowedPaymentMethodTypes (checked in Stripe test mode).
 */
export const STRIPE_JS_URL = 'https://js.stripe.com/endive/stripe.js';

/**
 * What the lock-in payment sheet may show: card only. Apple Pay and Google Pay are card wallets, so
 * they still show on phones that have them. Set on the page itself (deferred Elements, no client
 * secret), so the sheet never falls back to whatever the Stripe Dashboard turns on.
 */
export function payElementsOptions(cents: number, appearance: Record<string, unknown> = {}) {
  return { mode: 'payment', amount: cents, currency: 'usd', allowedPaymentMethodTypes: ['card'], appearance } as const;
}
/**
 * Link off: card on its own still lets Link in (card's Link funding), and Link brings its own Bank and
 * Klarna tabs plus "Secure, fast checkout with Link". That is what QATE78 showed. Checked against
 * Stripe test mode in test/stripe-sheet-live.test.ts.
 */
export const PAY_ELEMENT_OPTIONS = {
  layout: 'tabs',
  paymentMethodOrder: ['apple_pay', 'google_pay', 'card'],
  wallets: { applePay: 'auto', googlePay: 'auto', link: 'never' },
} as const;

